/**
 * Check if the bottom space is smaller than the minimum required space
 * @param element
 * @param minSpace
 */ function isBottomSpaceSmaller(element, minSpace) {
    // Get the element's bounding rectangle
    var rect = element.getBoundingClientRect();
    // Calculate the distance between the element's bottom and the viewport bottom
    var bottomSpace = window.innerHeight - rect.bottom;
    // Check if the bottom space is smaller than the minimum required space
    return bottomSpace < minSpace;
}
export { isBottomSpaceSmaller };
